import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f1bfcd9e&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=f1bfcd9e&prod&lang=scss&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&id=f1bfcd9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bfcd9e",
  null
  
)

export default component.exports